







































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "../store/index";
import { getQueryVariable } from "../common/common";
import moment from "moment";

export default Vue.extend({
	name: "ReportHeader",
	computed: {
		...mapState({
			checkInfo: (state: any) => store.getters.getCheckInfo,
			reportType: (state: any) => store.getters.getReportType,
			reportId: (state: any) => store.getters.getReportId,
			checkType: (state: any) => store.getters.getCheckType,
			productId: (state: any) => store.getters.getProductId,
		}),
		// reportId(){
		//   return getQueryVariable('reportId')
		// }
	},
	data() {
		return {
			isCanDownload: true,
		};
	},
	methods: {
		formatTime(val: Date, format: string) {
			return moment(val).format(format);
		},
		// 导出文件
		exportPostFiles(data: Blob, name: string) {
			const blob = new Blob([data], {
				type: "application/pdf",
			});
			const fileName = name;
			if ("download" in document.createElement("a") && (navigator as any).userAgent.indexOf("Edge") === -1) {
				// 非ie
				const ele = document.createElement("a");
				ele.download = fileName + ".pdf";
				ele.style.display = "none";
				ele.href = URL.createObjectURL(blob);
				document.body.appendChild(ele);
				ele.click();
				URL.revokeObjectURL(ele.href);
				document.body.removeChild(ele);
			} else {
				// ie
				navigator.msSaveBlob(blob, fileName + ".pdf");
			}
		},
		// 下载pdf
		downloadPDF() {
			this.$message({
				message: (this as any).$t("fOrH.downing"),
				type: "success",
			});
			if (!this.isCanDownload) {
				return false;
			}
			this.isCanDownload = false;
			// 报告类型
			const reportTypeRelation: any = {
				simple: (this as any).$t("app.simple"),
				originalText: (this as any).$t("app.origin"),
				detailPart: (this as any).$t("app.detail"),
				fullText: (this as any).$t("app.full"),
				preservation: (this as any).$t("app.preservation"),
				OneByOne: (this as any).$t("fOrH.oneReport"),
				simple_ft: (this as any).$t("app.simple"),
				originalText_ft: (this as any).$t("app.origin"),
				detailPart_ft: (this as any).$t("app.detail"),
				fullText_ft: (this as any).$t("app.full"),
				simple_en: (this as any).$t("app.simple") + ' report',
				originalText_en: (this as any).$t("app.origin") + ' report',
				detailPart_en: (this as any).$t("app.detail") + ' report',
				fullText_en: (this as any).$t("app.full") + ' report',
			};
			const reportType = reportTypeRelation[this.reportType] || (getQueryVariable("checkType") === "OneByOne" ? reportTypeRelation[this.checkType] : "");
			this.$http
				.post(
					"/api/ReportFile",
					{
						reportId: getQueryVariable("reportId"),
						productId: getQueryVariable("productId"),
						reportType: getQueryVariable("checkType") === "OneByOne" ? "one2One" : getQueryVariable("reportType"),
						checkTime: this.checkInfo.reportModel && this.checkInfo.reportModel.checkTime,
						checkType: getQueryVariable("checkType"),
					},
					{
						responseType: "blob",
					}
				)
				.then((res: any) => {
					this.isCanDownload = true;
					this.exportPostFiles(res.data, (this.checkInfo.reportModel && this.checkInfo.reportModel.title) + "（" + reportType + "）");
				});
		},
		// 初始化原文
		initReportHeader() {
			// console.log('初始化reportHeader');
		},
		// 转换大写
		toUpperCaseStr(val: string) {
			return val.toUpperCase();
		},
	},
	mounted() {
		this.initReportHeader();
	},
});
